<template>
  <span class="wnm-price" data-testid="wnm-price">{{ formattedPrice }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { formatPrice } from '~/utils/commonUtils';

const props = defineProps<{
  price: number;
  quantity?: number;
  isBigTicketItem?: boolean;
}>();

const { killswitches } = useKillswitches();

const formattedPrice = computed(() => {
  const quantity = props.quantity ?? 1;
  // ST items always scale, BT items are dependant on KS
  const scaleWithQuantity = (!props.isBigTicketItem || killswitches.isWNMBigTicketQuantityPricingEnabled) && quantity > 1;
  return formatPrice(scaleWithQuantity ? Number(props.price) * quantity : props.price);
});
</script>
